module.exports = __webpack_public_path__ + "img/brand-banner.bdbff487.png";